module.exports = {
	message: {
		hello_world: '世界 你好'
	},
	down: {
		grid_bot: '网格量化工具',
		overcome_emotional: '克服投资情绪',
		fortune_market: '轻松穿越牛熊',
		contact_email: '联系客服邮箱',
		copy_success: '复制成功',
		copy_failed: '复制失败',
		press_copy: '请长按邀请码进行复制',
		overseas: '需要海外',
		register_guide: '注册美区ID指引',
		recommend: '推荐',
		enterprise: '企业签名版',
		anytime: '随时随地',
		trade: '交易',
		stay_tuned: '敬请期待',

	},
	sign: {
		register_id: '注册账号',
		mobile_regist: '手机注册',
		email_regist: '邮箱注册',
		input_phone: '请输入手机号',
		input_email: '请输入邮箱地址',
		set_password: '请设置密码',
		password_rule: '8-16位数字、字母组合',
		password_warn: '要同时含有数字和字母，长度在8-16位之间',
		invite_code: '推荐人邀请码',
		agree: '我已阅读并同意',
		user_agr: '《用户协议》',
		privacy_agr: '《隐私协议》',
		and: '和',
		regist: '注册',
		agree_warn: '请先阅读并同意协议',
		already_regist: '已注册？点击下载',
		phone_warn: '手机号码输入有误，请重新填写',
		email_warn: '邮箱格式有误，请重新填写',
		input_code: '输入验证码',
		code_sended: '验证码已发送至：',
		re_get: '后重新获取',
		regist_success: '恭喜您注册成功！',
		down_app: '下载APP',
		user_exists: '该用户已存在',
		resend: '重新获取',
		wrong_code: '验证码有误',
		choose_area: '选择国家或地区',
		search: '搜索',
		mobile_xp: '手机号码',
		email_xp: '邮箱地址',
		code_xp: '验证码',
		get_code_xp: '获取验证码',
		get_code2_xp: '后重新获取',
		set_pwd: '设置密码',
		regist_text: '注册即代表阅读并同意',
		trade: '随时随地，移动交易',
		down: '下载',
		currently_regist: '正在注册',
		agreement: '平台服务条款',
		no_cn: '不支持中国大陆用户注册',
	},
	common: {
		jgz: 'JGZ',
		jgz_down: 'JGZ下载',
		invite_regist: '邀请注册',
		open_in_browser: '请在浏览器中打开',
		jgz_team: 'JGZ团队',
		refresh: '点击刷新',
		xp_team: 'XP团队',
		load: '加载中~',
		xp_network: '网络请求超时，请稍后重试',
	},
	invite: {
		scan_down: '扫码下载JGZ APP',
		invite_code: '邀请码',
		invite: '立即邀请',
		not_apple: '本活动与苹果公司无关',
		invite_friend: '邀请好友',
		get_bot: '一起量化',
		invite_xp: '邀请好友 一起量化',
		scan_down_xp: '扫码下载',
		invite_code_xp: '邀请链接',
		invite_text_xp: '也可通过以下方式邀请',
		invite_code2_xp: '复制邀请码',
		invite_url_xp: '复制链接',
		invite_hb_xp: '生成海报',
		invite_back: '返回',
		invite_save: '保存图片',
	},
	activity: {
		jgz_activity: 'JGZ活动',
		failed: '欧呦！获取失败。',
		course: '教程',
		service: '在线客服',
		consult: '咨询',
		service_text: '由于币安的相关政策规定，在2024年06月01日前未完成KYC的账户将会对其进行封禁，请各位用户知悉。如有疑问，请在APP联系',
		service_h2: '尊敬的用户',
		service_title: '关于未完成KYC账号封禁公告',
	},
	alarm: {
		how: '如何添加预警？',
		way: '登录状态下，打开任意交易对K线页面，点击预警按钮，即可添加价格预警。'
	},
	activityXP: {
		title: '新用户注册豪礼',
		h1: '加密交易所',
		h2: '注册豪礼等你拿',
		activityTime: '活动时间：2025/06/06 ~ 2025/08/31',
		activityRule: '活动规则',
		activityRuleDetail: '活动期间，注册并完成实名认证且累计交易金额达到100美元(含)以上的用户，自动参与瓜分30万美元。',
		exchangeRule: '兑奖规则',
		exchangeRuleDetail: '用户领奖金额将根据活动期间个人交易额与本交易所总交易额的占比份额进行分配。',
		exchangeType: '兑奖方式',
		exchangeTypeDetail: '兑奖奖金将于 2025/09/01 ~ 2025/09/07 期间自动发放至用户账户。',
	}
}